<!-- MODAL HEADER -->
<div class="modal-header">
  <h3 class="modal-title"><strong>End of the Year Stock Basis Adjustments</strong></h3>
  <div class="header-actions">
    <i class="fa" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;" (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- MODAL BODY -->
<form class="form-horizontal" [hidden]="minimise" novalidate>
<div class="modal-body no-body-scroll">

  @if (loadingData) {
<div class="modal-loading">
    <div class="loading-img">
      <i class="fa fa-spinner fa-pulse" style="font-size: 40px;"></i>
    </div>
  </div>
}

  @if (!loadingData) {
<div>

    <!-- Grid Row Info Table -->
    <div style="max-height: 100px; overflow-y: auto; overflow-x: auto; margin-bottom: 10px;">
      <table class="table table-hover table-bordered table-striped table-condensed" style="margin-bottom: 0;">
        <thead>
          <tr>
            <th>Home Office LEID</th>
            <th>Home Office Tax Code</th>
            <th>Home Office Reporting Period</th>
            <th>Maintenance Owner Name</th>
            <th>LE Name</th>
            <th>BoY Amt</th>
            <th>Adjustments</th>
            <th>EoY Stock Basis Amt</th>
          </tr>
        </thead>
        <tbody>
          @for (t of selectedGridRow; track $index) {
<tr>
            <td>{{ t.HO_LEID }}</td>
            <td>{{ t.HO_CDR_NO }}</td>
            <td>{{ t.HO_REPORTING_PERIOD }}</td>
            <td>{{ t.MAINTENANCE_OWNER_DESC }}</td>
            <td>{{ t.LE_NAME }}</td>
            <td>{{ t.BOY_BASIS_AMT }}</td>
            <td>{{ t.ADJ_BASIS_AMT }}</td>
            <td>{{ t.EOY_ADJ_BASIS_AMT }}</td>
          </tr>
}
        </tbody>
      </table>
    </div>

    <!-- Split Basis Option -->
    <div class="row" style="margin-bottom: 10px;">
      <div class="col-sm-3">
        <label>Split Basis Based on Ownership:</label>
      </div>
      <div class="col-sm-2">
        <input type="radio" id="splitYes" [(ngModel)]="isSplitOnOwnership" value="Yes"
               (ngModelChange)="onSplitOwnershipChange()" name="splitOwnership">
        <label for="splitYes">Yes</label>
      </div>
      <div class="col-sm-2">
        <input type="radio" id="splitNo" [(ngModel)]="isSplitOnOwnership" value="No"
               (ngModelChange)="onSplitOwnershipChange()" name="splitOwnership">
        <label for="splitNo">No</label>
      </div>
    </div>

    <!-- EoY Adjustments Table -->
    <table class="table table-striped table-bordered table-condensed">
      <thead>
        <tr>
          <th>Owner LEID</th>
          <th>Owner Tax Code</th>
          <th>Owner Reporting Period</th>
          <th>Owner ME Code</th>
          <th>Current Ownership %</th>
          <th>Previous Ownership %</th>
          <th>End of Year Stock Basis</th>
        </tr>
      </thead>
      <tbody>
        @if (eoyAdjmentsLoading) {
<tr>
          <td colspan="7" style="text-align: center; height: 110px; vertical-align: middle;">
            <i class="fa fa-spinner fa-pulse" style="font-size: 40px;"></i>
          </td>
        </tr>
}
        @if (!eoyAdjmentsLoading) {

          @for (t of getSortedAdjustmentDtls(); track trackByAdjKey($index, t)) {
<tr>
            <td>{{ t.OWNER_LEID }}</td>
            <td>{{ t.OWNER_CDR_NO }}</td>
            <td>{{ t.OWNER_REPORTING_PERIOD }}</td>
            <td>{{ t.OWNER_ME_CODE }}</td>
            <td>{{ t.CURR_RATIO }}</td>
            <td>{{ t.PREV_RATIO }}</td>
            <td>
              @if (isSplitOnOwnership == 'Yes') {
<span>{{ t.AMOUNT }}</span>
}
              @if (isSplitOnOwnership == 'No') {
<input
                     type="number" [(ngModel)]="t.AMOUNT"
                     [ngModelOptions]="{standalone: true}"
                     class="form-control input-sm"
                     step="0.01" (blur)="roundEoYAmountToTwoDecimals(t)">
}
            </td>
          </tr>
}
        
}
      </tbody>
    </table>

  </div>
}
</div>
</form>

<!-- MODAL FOOTER -->
<div class="modal-footer" [hidden]="minimise">
  <button class="btn btn-info btn-sm" type="button" [disabled]="isSaveClicked" (click)="save()" style="margin-right: 5px;">
    @if (isSaveClicked) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
  </button>
  <button class="btn btn-warning btn-sm" type="button" (click)="cancel()">Cancel</button>
</div>

<!-- Confirmation Dialog -->
@if (showConfirmationDialog) {
<div class="confirmation-overlay">
  <div class="confirmation-dialog">
    <div class="modal-header">
      <h4 class="modal-title">{{ confirmationHeader }}</h4>
    </div>
    <div class="modal-body">
      <p>{{ confirmationMessage }}</p>
    </div>
    <div class="modal-footer">
      <button class="btn btn-info btn-sm" type="button" (click)="confirmSave()">Yes</button>
      <button class="btn btn-warning btn-sm" type="button" (click)="cancelConfirmation()" style="margin-left: 5px;">No</button>
    </div>
  </div>
</div>
}
